/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Step4_NameInputs */

const en_dr_step4_name = /** @type {(inputs: Dr_Step4_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 · Ideas (brainwriting)`)
};

const id_dr_step4_name = /** @type {(inputs: Dr_Step4_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4 · Ide (brainwriting)`)
};

/**
* | output |
* | --- |
* | "4 · Ideas (brainwriting)" |
*
* @param {Dr_Step4_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_step4_name = /** @type {((inputs?: Dr_Step4_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Step4_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_step4_name(inputs)
	return en_dr_step4_name(inputs)
});